import { useMutation } from "react-query";
import downloadPo from "../services/downloadPo";

function useDownloadPo() {
  return useMutation(["download-po"], downloadPo);
}

export default useDownloadPo;
